// src/plugins/push-foreground.js
import store from '@/store'
import { GlobalEventEmitter } from '@/utils/GlobalEventEmitter'
import { firebase } from '@/views/apps/notification/firebase/firebase' // <-- add

let installed = false
export function installForegroundPushSync() {
    if (installed) return
    installed = true

    // Ensure onMessage is subscribed globally (idempotent inside your wrapper)
    try { firebase().getMessage() } catch (_) {}

    GlobalEventEmitter.$on('newMessageReceived', () => {
        store.dispatch('notification/fetchNotifications').catch(() => {})
    })

}
